import {Injectable} from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import {Store} from "@ngxs/store";
import {AccountState} from "../../states/account.state";

@Injectable({
  providedIn: 'root'
})
export class ThankYouGuard  {

  constructor(
    private router: Router,private store:Store,
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const performingSignup = this.store.selectSnapshot(AccountState.getPerformingSignup);
    console.log('is doing signup', performingSignup)
    if(performingSignup){
      return true;
    } else {
      this.router.navigate(['/home'])
    }
  }
}
